import {createSuggestionsCache} from "@pg-design/search-combobox-module";

import {PRICES_SEARCH_CACHE_MAX, PRICES_SEARCH_CACHE_TTL_MS} from "../constants/prices_search";
import {IPricesAddressSearchResult, IPricesAddressSource} from "../types/IPricesSearchModel";
import {fetchRcnAddresses} from "./fetch_rcn_addresses";

/**
 * RCN `/v1/addresses?q=` straight from the browser, at most 50 rows and no total. A server proxy with
 * unlimited, diacritics-insensitive search can replace it behind the same interface.
 */
export const rcnDirectAddressSource: IPricesAddressSource = {
    id: "rcn",
    search: async (query, {limit, signal}) => {
        const response = await fetchRcnAddresses(query, {limit, signal});

        return {rows: response.addresses, capped: response.capped};
    }
};

/** Shared by the main and the scoped ("Pokaż więcej", building numbers) queries, so going back to a phrase costs no request. */
export const pricesAddressSearchCache = createSuggestionsCache<IPricesAddressSearchResult>({max: PRICES_SEARCH_CACHE_MAX, ttlMs: PRICES_SEARCH_CACHE_TTL_MS});

export const getPricesAddressSearchCacheKey = (source: IPricesAddressSource, query: string, limit: number): string => `${source.id}|${limit}|${query}`;
import {createSuggestionsCache} from "@pg-design/search-combobox-module";

import {PRICES_SEARCH_CACHE_MAX, PRICES_SEARCH_CACHE_TTL_MS} from "../constants/prices_search";
import {IPricesAddressSearchResult, IPricesAddressSource} from "../types/IPricesSearchModel";
import {fetchRcnAddresses} from "./fetch_rcn_addresses";

/**
 * RCN `/v1/addresses?q=` straight from the browser, at most 50 rows and no total. A server proxy with
 * unlimited, diacritics-insensitive search can replace it behind the same interface.
 */
export const rcnDirectAddressSource: IPricesAddressSource = {
    id: "rcn",
    search: async (query, {limit, signal}) => {
        const response = await fetchRcnAddresses(query, {limit, signal});

        return {rows: response.addresses, capped: response.capped};
    }
};

/** Shared by the main and the scoped ("Pokaż więcej", building numbers) queries, so going back to a phrase costs no request. */
export const pricesAddressSearchCache = createSuggestionsCache<IPricesAddressSearchResult>({max: PRICES_SEARCH_CACHE_MAX, ttlMs: PRICES_SEARCH_CACHE_TTL_MS});

export const getPricesAddressSearchCacheKey = (source: IPricesAddressSource, query: string, limit: number): string => `${source.id}|${limit}|${query}`;
